import { fetchApi } from "lib/actions/fetcher";
import { endpointsAutodeskImport } from "./endpointsAutodeskImport";
import { AutodeskImportSelectionModel } from "../types/AutodeskImportSelectionModel";
import { AutodeskImportPreviewModel } from "../types/AutodeskImportPreviewModel";

export async function previewAutodeskSelection(
  selection: AutodeskImportSelectionModel,
): Promise<AutodeskImportPreviewModel> {
  const response = await fetchApi({
    ...endpointsAutodeskImport.selectionPreview,
    body: { ...selection },
  });
  return response.json();
}
